import { Grid, Group, MultiSelect, Select, Switch, Text } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "../../components/Button";
import DescriptionField from "../../components/descriptionField";
import { DropzoneComponent } from "../../components/DropzoneComponent/DropzoneComponent";
import InputField from "../../components/inputField";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import NumberInputField from "../../components/NumberInputField";
import { alphaNumericRegex, descriptionRegex } from "../../constants/index";
import { addAndEditData } from "../generalPostAndEditData";
import { loadIndustries } from "../Industries/loadData";
import { loadLookupsByTypes } from "../lookuplist/loadData";
import { loadSkills } from "../Skills/loadData";
import { loadSpecificUsers } from "../Users/loadData";
import { loadEmpLocations, loadJobs } from "./loadData";

export const AddJob = ({
  opened,
  setOpened,
  setUpdate,
  update,
  editData,
  setEditData,
  editModalState,
  setEditModalState,
  setLoading,
}) => {
  console.log("editData", editData);
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      createdBy: "",
      jobTitle: "",
      jobDescription: "",
      empLocation: "",
      industry: [],
      skills: [],
      salaryRange: "",
      minSalary: "",
      maxSalary: "",
      benefits: "",
      commission: false,
      veteranShare: false,
      relocation: false,
      remotely: false,
      jobType: [],
      education: "",
      experience: "",
      expiryDate: new Date(new Date().setDate(new Date().getDate() + 30)),
      jobAttachments: [],
    },

    validate: {
      jobTitle: (value) =>
        value?.trim()?.length > 1 && alphaNumericRegex.test(value.trim())
          ? null
          : "Alphabetic and Numeric Name with 2 or more characters",
      createdBy: (value) => (value ? null : "Please Select Company"),
      jobDescription: (value) =>
        value?.trim()?.length > 20 && descriptionRegex.test(value.trim())
          ? null
          : "Description with 20 or more characters",
      benefits: (value) =>
        value?.trim()?.length > 20 && descriptionRegex.test(value.trim())
          ? null
          : "Describe Benefits with 20 or more characters",
      empLocation: (value) => (value ? null : "Please Select Location"),
      industry: (value) =>
        value?.length > 0 ? null : "Please Select Industry",
      skills: (value) => (value?.length > 0 ? null : "Please Select Skills"),
      minSalary: (value) => (value ? null : "Please Select Min Salary"),
      maxSalary: (value) => (value ? null : "Please Select Max Salary"),

      jobType: (value) => (value?.length > 0 ? null : "Please Select Job Type"),
      education: (value) => (value ? null : "Please Select Education"),
      experience: (value) => (value ? null : "Please Select Experience"),
      jobAttachments: (value) =>
        value?.length > 0 ? null : "Please Select Job Attachments",
    },
  });
  useEffect(() => {
    form.setFieldValue(
      "salaryRange",
      form.values.minSalary + "-" + form.values.maxSalary
    );
  }, [form.values.minSalary, form.values.maxSalary]);

  const onSubmit = (values) => {
    console.log("values these are", values);
    // console.log(values);
    let formData = new FormData();
    Object.keys(values).forEach((key) => formData.append(key, values[key]));

    let url = "";
    if (editModalState) {
      values.jobId = editData._id;
      url = "job/editJob";
      values.skills = values.skills.join(",");
      values.industry = values.industry.join(",");
      values.jobType = values.jobType.join(",");
      setEditData({});
      setEditModalState(false);
      addAndEditData(values, setOpened, setUpdate, url);
    } else {
      url = "job/addJob";
    }
    form.reset();
    setLoading(true);
    if (!editModalState) {
      addAndEditData(formData, setOpened, setUpdate, url);
    }
  };

  const location = useLocation();
  const [companies, setCompanies] = useState([]);
  const [empLocations, setEmpLocations] = useState([]);
  const [allIndustry, setIndustry] = useState([]);
  const [allSkills, setSkills] = useState([]);
  const [allJobType, setJobType] = useState([]);
  const [allEducation, setEducation] = useState([]);
  const [allExperience, setExperience] = useState([]);
  console.log("companies", companies);

  useEffect(() => {
    loadSpecificUsers("Companies", setLoading).then(setCompanies);
    loadIndustries(setLoading).then(setIndustry);
    loadSkills(setLoading).then(setSkills);
    loadLookupsByTypes(setLoading, "jobType").then(setJobType);
    loadLookupsByTypes(setLoading, "education").then(setEducation);
    loadLookupsByTypes(setLoading, "experience").then(setExperience);
  }, [location.pathname, update]);

  useEffect(() => {
    if (form.values.createdBy !== undefined) {
      loadEmpLocations(setLoading, form.values.createdBy).then(setEmpLocations);
    }
  }, [form.values.createdBy]);
  const [reset, setReset] = useState(false);
  useEffect(() => {
    if (
      editModalState &&
      companies.length > 0 &&
      allIndustry.length > 0 &&
      allSkills.length > 0 &&
      allJobType.length > 0 &&
      allEducation.length > 0 &&
      allExperience.length > 0 &&
      empLocation.length > 0
    ) {
      console.log("TEST commission", editData.commission);
      console.log("TEST veteranShare", editData.veteranShare);
      console.log("TEST relocation", editData.relocation);
      console.log("TEST remotely", editData.remotely);
      form.setValues({
        createdBy: editData?.createdBy,
        jobTitle: editData.jobTitle,
        jobDescription: editData.jobDescription,
        empLocation: editData?.empLocation?._id,
        industry: editData?.industries?.map((item) => item?.industry?._id),
        skills: editData?.skills?.map((item) => item?.skills?._id),
        minSalary: parseInt(editData.minSalary),
        maxSalary: parseInt(editData.maxSalary),
        benefits: editData.benefits,
        commission: editData.commission,
        veteranShare: editData.veteranShare,
        relocation: editData.relocation,
        remotely: editData.remotely,
        jobType: editData?.jobType?.map((item) => item?.jobType?._id),
        education: editData?.education?._id,
        experience: editData?.experience,
        expiryDate: new Date(editData.expiryDate),
        jobAttachments: ["", ""],
      });
    }
  }, [opened, reset]);
  const createdBy = companies.map((item) => ({
    label: item.firstName + " " + item.lastName,
    value: item._id,
  }));
  const empLocation = empLocations.map((item) => ({
    label: item.locationName,
    value: item._id,
  }));

  const industry = allIndustry.map((item) => ({
    label: item.industryName,
    value: item._id,
  }));

  const skills = allSkills.map((item) => ({
    label: item.skillName,
    value: item._id,
  }));
  const jobType = allJobType.map((item) => ({
    label: item.lookupName,
    value: item._id,
  }));
  const experience = allExperience.map((item) => ({
    label: item.lookupName,
    value: item._id,
  }));

  const education = allEducation.map((item) => ({
    label: item.lookupName,
    value: item._id,
  }));
  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Grid>
        <Grid.Col lg={12}>
          <Text mb={0} weight={500}>
            Company
          </Text>
          <Select
            disabled={editModalState}
            required
            withAsterisk={false}
            placeholder="Select Company"
            data={createdBy}
            // searchable
            nothingFound="No Company found"
            {...form.getInputProps("createdBy")}
          />
        </Grid.Col>
        <Grid.Col lg={12}>
          <Text mb={0} weight={500}>
            Job Title
          </Text>
          <InputField
            width="100%"
            placeholder="Enter Job Title"
            form={form}
            validateName="jobTitle"
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Min Salary
          </Text>
          <NumberInputField
            min={0}
            max={form.values.maxSalary || 99999999}
            width="100%"
            placeholder="Enter Job Title"
            form={form}
            validateName="minSalary"
          />
        </Grid.Col>

        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Max Salary
          </Text>
          <NumberInputField
            disabled={
              form.values.minSalary === undefined ||
              form.values.minSalary === null ||
              form.values.minSalary === ""
            }
            min={form.values.minSalary}
            max={99999999}
            width="100%"
            placeholder="Enter Job Title"
            form={form}
            validateName="maxSalary"
          />
        </Grid.Col>
        <Grid.Col lg={12}>
          <Text mb={0} weight={500}>
            Salary Range
          </Text>
          <InputField
            disabled={true}
            width="100%"
            placeholder="Salary Range"
            form={form}
            validateName="salaryRange"
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Commission?
          </Text>
          <Switch
            checked={form.values.commission}
            {...form.getInputProps("commission")}
            label={!form.values.commission ? "Not Applicable" : "Applicable"}
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Veteran Share?
          </Text>
          <Switch
            checked={form.values.veteranShare}
            {...form.getInputProps("veteranShare")}
            label={!form.values.veteranShare ? "Not Applicable" : "Applicable"}
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Relocation?
          </Text>
          <Switch
            checked={form.values.relocation}
            {...form.getInputProps("relocation")}
            label={!form.values.relocation ? "Not Applicable" : "Applicable"}
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Remotely?
          </Text>
          <Switch
            checked={form.values.remotely}
            {...form.getInputProps("remotely")}
            label={!form.values.remotely ? "Not Applicable" : "Applicable"}
          />
        </Grid.Col>
        <Grid.Col lg={12}>
          <Text mb={0} weight={500}>
            Benefits
          </Text>
          <DescriptionField
            maxRows={4}
            minRows={3}
            autosize={true}
            width="100%"
            placeholder="Enter Benefits"
            form={form}
            validateName="benefits"
          />
        </Grid.Col>
        <Grid.Col lg={12}>
          <Text mb={0} weight={500}>
            Job Description
          </Text>
          <DescriptionField
            maxRows={4}
            minRows={3}
            autosize={true}
            width="100%"
            placeholder="Enter Job Description"
            form={form}
            validateName="jobDescription"
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Employer Location
          </Text>
          <Select
            required
            disabled={
              form.values.createdBy === undefined ||
              form.values.createdBy === null ||
              form.values.createdBy === "" ||
              editModalState
            }
            withAsterisk={false}
            placeholder="Select Employer Location"
            data={empLocation}
            // searchable
            nothingFound="No Employer Location found"
            {...form.getInputProps("empLocation")}
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Industry
          </Text>
          <MultiSelect
            required
            withAsterisk={false}
            placeholder="Select Industry"
            data={industry}
            // searchable
            nothingFound="No Industry found"
            {...form.getInputProps("industry")}
          />
        </Grid.Col>

        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Skills
          </Text>
          <MultiSelect
            required
            withAsterisk={false}
            placeholder="Select Skills"
            data={skills}
            // searchable
            nothingFound="No Skills found"
            {...form.getInputProps("skills")}
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Job Type
          </Text>
          <MultiSelect
            required
            withAsterisk={false}
            placeholder="Select Job Type"
            data={jobType}
            // searchable
            nothingFound="No Job Type found"
            {...form.getInputProps("jobType")}
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Education
          </Text>
          <Select
            required
            withAsterisk={false}
            placeholder="Select Education"
            data={education}
            // searchable
            nothingFound="No Education found"
            {...form.getInputProps("education")}
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Experience
          </Text>
          <Select
            required
            withAsterisk={false}
            placeholder="Select experience"
            data={experience}
            // searchable
            nothingFound="No experience found"
            {...form.getInputProps("experience")}
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Text mb={0} weight={500}>
            Job Expiry Date
          </Text>
          <DatePicker
            placeholder="Pick date"
            minDate={new Date().setDate(new Date().getDate() + 30)}
            {...form.getInputProps("expiryDate")}
          />
        </Grid.Col>
        <Grid.Col hidden={editModalState}>
          <Text mb={0} weight={500}>
            Job Attachments
          </Text>

          <DropzoneComponent form={form} validateName="jobAttachments" />
        </Grid.Col>
      </Grid>

      <Group position="right" pt="xl">
        <Button
          title={"Clear"}
          fontWeight="700"
          onClick={() => {
            if (editModalState) {
              form.reset();
              // setReset(true);
              form.setValues({
                createdBy: editData?.createdBy,
                empLocation: editData?.empLocation?._id,
                jobAttachments: ["", ""],
              });
            } else {
            }
          }}
        />
        <Button
          title={editModalState ? "Edit" : "Add"}
          primary={true}
          fontWeight="700"
          type="submit"
        />
      </Group>
    </form>
  );
  return (
    <ModalWrapper
      opened={opened}
      setOpened={setOpened}
      InternalComponent={InternalContent}
      title={editModalState ? "Edit Job" : "Add Job"}
      size="60%"
      form={form}
      setEditData={setEditData}
      setEditModalState={setEditModalState}
      addEdit={true}
    />
  );
};
